import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function FooterCpn(){

    const { t } = useTranslation("translation");
    return (
        <>
           <div className="Layout_footer__A5bFC">
                <div className="Footer_mainDiv__Oc76Z">
                    <div className="Footer_componentDiv__zEry3">
                    <div className="Footer_upper__UqGN4">
                        <div className="Footer_newsletterDiv__f3Qbn">
                        <div className="Footer_logoDiv__pfCVV space_logo">
                            <a href="/">
                            <img
                                alt="Coin Bureau"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                // src="https://h2tmediagroup.com/wp-content/uploads/2024/03/Logo-H2T-180x60-1.png"
                                src="/asset/images/logo3.png"
                                className="space_img"
                                style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                objectFit: "contain",
                                color: "transparent",
                               
                                }}
                            />
                            <span className="fontsize_logo space_logo_small" style={{position:"absolute",fontWeight:"900",color:"red"}}>
                          <span className="space_h2t_small">H2T</span>
                          <span style={{display:"block"}}>
                            MEDIA GROUP
                          </span>
                        </span>
                            </a>
                            
                        </div>
                        <div className="Footer_descriptionDiv__H3tPG">
                            Free Crypto Coverage Direct to Your Inbox
                        </div>
                        <div className="Footer_emailDiv__K8kBw">
                            <input
                            className="Footer_inputEmail__1BcK6"
                            type="email"
                            id="email"
                            placeholder="Enter your email"
                            defaultValue=""
                            />
                            <button className="Footer_buttonDiv__AkNFX">Subscribe</button>
                        </div>
                        <div>
                            <p style={{ height: 20 }} />
                        </div>
                        </div>
                        <div className="Footer_pagesDiv__deMVs">
                        <div className="Footer_navCompDiv__tyIT2">
                            <div className="Footer_navigationDiv__d1mZ7">
                            <div className="Footer_navigationTitle__e3sf1">Điều hướng</div>
                            <div className="Footer_navigationList___L6vY">
                                <ul>
                                <li>
                                    <Link to="/blog/">Bài viết</Link>
                                </li>
                                {/* <li>
                                    <a href="/blog/">{t("Articles")}</a>
                                </li> */}
                                <li>
                                    <Link to="/deals/">Giao dịch</Link>
                                </li>
                                <li>
                                    <Link to="/all_coin/">Tiền ảo</Link>
                                </li>

                                {/* <li>
                                    <a href="/videos/">Videos</a>
                                </li>
                                <li>
                                    <a href="/resource-hub/">Resource Hub</a>
                                </li> */}
                                </ul>
                            </div>
                            </div>
                            <div className="Footer_companyDiv__825Bk">
                            <div className="Footer_companyTitle__d_I8B">Công ty</div>
                            <div className="Footer_companyList__JZ1cG">
                                <ul>
                                {/* <li>
                                    <a href="/about/">About</a>
                                </li> */}
                                {/* <li>
                                    <a href="/socials/">Socials</a>
                                </li> */}
                                {/* <li>
                                    <a href="/disclaimer/">Disclaimer</a>
                                </li>
                                <li>
                                    <a href="/privacy-policy/">Privacy Policy</a>
                                </li> */}
                                <li>
                                    <a href="/socials/">Chính sách bảo mật</a>
                                </li>
                                <li>
                                    <a href="/terms-of-service/">Điều khoản dịch vụ</a>
                                </li>
                                </ul>
                            </div>
                            </div>
                        </div>
                        <div className="Footer_socialDiv__ca80N">
                            <div className="Footer_socialTitle___zY9d">Xã hội</div>
                            <div className="Footer_socialList__vm376">
                            {/* <div className="Footer_discord__FXrWL">
                                <a
                                href="https://go.coinbureau.com/cb-discord"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="go to discord"
                                >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
                                </svg>
                                </a>
                            </div> */}
                            <div className="Footer_twitter__GQvLZ">
                                <a
                                href="https://twitter.com/coinbureau"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="go to twitter"
                                >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
                                </svg>
                                </a>
                            </div>
                            <div className="Footer_youtube__6u3OY">
                                <a
                                href="https://www.youtube.com/channel/UCqK_GSMbpiV8spgD3ZGloSw"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="go to youtube"
                                >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                                </svg>
                                </a>
                            </div>
                            {/* <div className="Footer_linkedin__DKAX2">
                                <a
                                href="https://www.linkedin.com/company/coin-bureau"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="go to linkedin"
                                >
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                                </svg>
                                </a>
                            </div> */}
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="Footer_lower__N59_t">
                        © H2T Media Group 2025 copyrights. All Rights Reserved.
                    </div>
                    {/* <p className="Footer_lower__N59_t">
                        This site contains affiliate links to products/services. We may receive
                        a commission for purchases made through these links.
                    </p> */}
                    </div>
                </div>
           </div>
        </>
    );
}

export default FooterCpn;